// tasks name is derived from the type of the task + the function name

export const AllowedTaskTypes = [
  'sftpOperationdirectoryList',
  'sftpOperationdeleteFile',
  'sftpOperationcopyFile',
  'sftpOperationcopyFileToS3',
  'sftpOperationmoveFile',
  'fileOperationdeleteFileFromS3',
  'fileOperations3DirectoryList',
  'dataOperationbatch',
  'dataOperationdedup',
  'fileOperationappend',
];

export const AllowedTaskFunctions = [
  'directoryList',
  'deleteFile',
  'copyFile',
  'copyFileToS3',
  'deleteFileFromS3',
  'moveFile',
  's3DirectoryList',
  'batch',
  'dedup',
  'append',
];

export const AllowedTaskTypePrefixes = ['dataOperation', 'fileOperation', 'sftpOperation'];
